import React, { Key, useContext } from "react";
import AwesomeIcon from "../AwesomeIcon";
import { faCircleCheck, faDiamondExclamation } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import { GatewayContext } from "./GatewayContext";
import { GatewayContextProps, GatewayData } from "./types";
import { format } from "date-fns";
import { truncate } from "lodash";
import { t } from "i18next";

function GatewayDropdown() {
  const { totalGateway, offlineGatewayCount, offlineGatewayData, formatTimeDifference } =
    useContext<GatewayContextProps>(GatewayContext);

  return (
    <div className="text-gray-900 dark:text-gray-100 text-md">
      {!offlineGatewayCount ? (
        <div className="bg-green-300 dark:bg-green-800 flex space-x-4 px-5 py-4 items-center">
          <AwesomeIcon
            name={faCircleCheck}
            className="text-green-700 dark:text-green-400"
          />
          <p className="font-medium text-md">
            {t("gateways_are_online", { totalGateway })}
          </p>
        </div>
      ) : (
        <>
          <div className="bg-yellow-300 dark:bg-yellow-800 flex space-x-4 px-5 py-4 items-center">
            <AwesomeIcon
              name={faDiamondExclamation}
              className="text-yellow-700 dark:text-yellow-500"
            />
            <p className="font-medium text-md">
              {t("gateways_are_offline", { offlineGatewayCount, totalGateway })}
            </p>
          </div>
          <div className="p-5 max-h-[300px] space-y-5 overflow-y-auto scrollbar-light dark:scrollbar">
            <div className="space-y-5">
              {offlineGatewayData?.map((obj: GatewayData, index: Key) => (
                <div key={index}>
                  <p className="text-md text-gray-600 dark:text-gray-400 uppercase">
                    {obj?.workspace_name}
                  </p>
                  <div className="space-y-5">
                    {obj?.gateway?.map((item, index: Key) => (
                      <div
                        key={index}
                        className={classNames(
                          "border rounded-lg border-gray-500/50 space-y-2 p-4 my-3"
                        )}
                      >
                        <p className="font-medium" title={item?.gateway_name}>
                          {truncate(item?.gateway_name, { length: 30 })}
                        </p>
                        <p className="text-yellow-600 dark:text-yellow-500">
                          {t("offline_for")} {formatTimeDifference(item?.time_difference)}{" "}
                          <span className="text-gray-800 dark:text-gray-200">
                            {t("since_key")}{" "}
                            {format(new Date(item?.last_online), "h:mm a, d MMM")}{" "}
                          </span>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default GatewayDropdown;
